
//add to cart and update cartmini
function addBasketEventListener(element) {
    $(element).submit(function (e) {
        //console.log("add to cart")
        var url = $(".js-ecom-container").attr("data-cart-id");
        var form = $(this);
        var btnText = form.find(".js-ecom-product-button-text");
        var btnSpinner = form.find(".js-ecom-product-button-spinner");
        var checkStockMode = $(this).data("check-stock");

        e.preventDefault();
        if (url && form.attr("data-disabled") == "false") {
            form.attr("data-disabled", "true")
            $.ajax(
            {
                url: "Default.aspx?id=" + url,
                type: "POST",
                data: $(this).serialize() + "&Redirect=false",
                dataType: "html",
                cache: false,
                traditional: true,
                beforeSend: function () { 
                    btnText.hide();
                    //set spinner icon
                    //btnSpinner.html("<i class='fa fa-spinner fa-spin js-ecom-product-button-spinner'></i>");
                    btnSpinner.html("<img src='/files/images/svg/loading.svg' width='25px' class='js-ecom-product-button-spinner'/>");
                },
                complete: function (data, status, jqXHR) {
                    setTimeout(function () {
                        btnSpinner.html("<i class='js-ecom-product-button-spinner'></i>");
                        btnText.show();
                    }, 600);
                    form.trigger("reset");
                    form.attr("data-disabled", "false");
                },
                success: function (data, textStatus, jqXHR) {
                    //console.log("added success!");
                    btnSpinner.html("<i class='fa fa-check'></i>");
                    //if (checkStock(checkStockMode, data, form)) {
                    $(".minicart-wrap").html($(data).filter(".minicart-wrap").html());
                    updateCartMiniIcon($(data));
                    $(".js-cartmini").show();
                    //$.growlUI('Produktet blev tilføjet til kurven'); 

                    //}
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    //console.log(jqXHR);
                    //console.log(textStatus);
                    //console.log(errorThrown);
                }
            });
            // make button not focused
            $(".js-ecom-product-button").blur();
            return false;
        } else {
            //console.log("url not defined or form disabled");
            return false;
        }
    });
}

function checkStock(checkStockMode, data, form) {
    if (checkStockMode == "" || checkStockMode == "ignore") return true;

    var $submittedProducts = form.find(".js-ecom-product-quantity");
    if ($submittedProducts.length < 1) return false; //if no submitted products

    var $response = $(data).filter(".js-cartmini");
    if ($response.length < 1) return false; //if no response

    var failedProducts = [];
    var succededProducts = [];
    $submittedProducts.each(function () {
        //console.log("p");
        if ($(this).data("service") == "" || $(this).data("service").toLowerCase() == 'true') return true; //skip service products
        //console.log($response.html())
        var productId = $(this).data("productid");
        //console.log(productId)
        var $newOrderline = $response.find(".js-orderline[data-productid='" + productId + "']")
        var $oldOrderline = $(".js-cartmini").find(".js-orderline[data-productid='" + productId + "']")
        //console.log($newOrderline)
        if ($newOrderline.length < 1) { //Line not added
            failedProducts.push({ "product": $(this), "stock": -1 });
            return true;
        } else if ($oldOrderline.length < 1) { //Line added
            succededProducts.push({ "product": $(this), "quantity": $newOrderline.data("quantity") });
            return true;
        } else if ($newOrderline.data("quantity") - $oldOrderline.data("quantity") > 0) { //products have been added to existing orderline
            succededProducts.push({ "product": $(this), "quantity": $newOrderline.data("quantity") - $oldOrderline.data("quantity") });
            return true;
        } else { //no products have been added to existing orderling
            failedProducts.push({ "product": $(this), "stock": $newOrderline.data("stock") });
        }
    });

    function handleFailedProducts($productNameElement, $bodyElement, $failedProduct) {
        var clone = $productNameElement.clone()
        clone.html($failedProduct["product"].data("productname"))
        clone.appendTo($bodyElement);
    }

    if (checkStockMode == "break") {
        //console.log(failedProducts.length);
        if (failedProducts.length > 0) { //Handle failed products
            var $productNameElement = $(".js-stock-check-modal-break").find(".js-stock-check-productname");
            var $bodyElement = $productNameElement.closest(".js-stock-check-body");
            $productNameElement.remove();
            for (var i = 0; i < failedProducts.length; i++) {
                handleFailedProducts($productNameElement, $bodyElement, failedProducts[i]);
            }
            $(".js-stock-check-modal-break").modal('show');
            return false;
        }
        return true;
    }
}

//update cartminiicon quantity & price
function updateCartMiniIcon(context) {
    if ($(".js-cartmini-total-count", context).length) {
        $(".js-cartmini-total-icon-count").html($(".js-cartmini-total-count", context).val());
    } else {
        $(".js-cartmini-total-icon-count").html("0");
    }
    if ($(".js-cartmini-total-total", context).length) {
        $(".js-cartmini-icon-total").html($(".js-cartmini-total-total", context).val());
    } else {
        $(".js-cartmini-icon-total").html("");
    }
}

//redirect function
function redirect(loc) {
    if (loc && loc[0] != '/' && !(new RegExp('^[a-z]+://').test(loc))) {
        // loc is the relative path your wish to redirect to
        var b = document.getElementsByTagName('base');
        if (b && b[0] && b[0].href) {
            if (b[0].href.substr(b[0].href.length - 1) == '/' && loc.charAt(0) == '/') {
                loc = loc.substr(1);
            }
            loc = b[0].href + loc;
        }
    }
    location.href = loc;
}

function setupIncDec() {
    //input spinners

    $('.js-input-spinner-up').off().on('click', function () {
        var input = $(this).closest(".js-input-spinner").find(".js-ecom-product-quantity");
        input.val(parseInt(input.val(), 10) + 1);
        input.trigger("change");
    });
    $('.js-input-spinner-down').off().on('click', function () {
        var input = $(this).closest(".js-input-spinner").find(".js-ecom-product-quantity");
        if (input.val() > 0) { // Do not allow amount below 0
            input.val(Number(input.val()) - 1);
            input.trigger("change");
        }
    });

}



////hide cartmini on off click
//$(document).bind("mouseup touchend", function (e) {
//    var cartmini = $(".js-cartmini-container");
//    if (!cartmini.is(e.target)
//        && cartmini.has(e.target).length === 0) {
//        $(".js-cartmini").hide();
//    }
//});

function configureOrderUpdate() {

    $("input.js-ecom-product-quantity").focus(function () { $(this).select(); });

    $("#orderupdate .js-ecom-product-quantity").on("change", function (e) {
        $(this).closest("form").submit();
    })


    $("#orderupdate").on("submit", function (e) {
        e.preventDefault();
        $form = $(e.target);
        //block form..
        $("#main-content").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<img src="/files/images/svg/loading.svg" width="25px" class="js-ecom-product-button-spinner"/>' });
        $.post($form.attr("action"), $form.serialize())
            .always(function () {
                //unblock form..
                $("#main-content").unblock();
            })
            .done(function (data, textStatus, jqXHR) {
                if (textStatus == "success") {
                    $("#main-content").replaceWith($(data).find("#main-content"));
                    $(".minicart-wrap").replaceWith($(data).find(".minicart-wrap"));
                    setupIncDec();
                    configureOrderUpdate();
                } else jqXHR.reject();
            })
            .fail(function () {
                //..
            });
    });

    $("#ordervoucherupdate").on("submit", function (e) {
        e.preventDefault();
        $form = $(e.target);
        //block form..
        $("#main-content").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<i class="fa fa-spinner fa-spin"></i>' });

        $.post($form.attr("action"), $form.serialize())
            .always(function () {
                //unblock form..
                $("#main-content").unblock();
            })
            .done(function (data, textStatus, jqXHR) {
                if (textStatus == "success") {
                    $("#main-content").replaceWith($(data).find("#main-content"));
                    $(".minicart-wrap").replaceWith($(data).find(".minicart-wrap"));
                    setupIncDec();
                    configureOrderUpdate();
                } else jqXHR.reject();
            })
            .fail(function () {
                //..
            });
    });

    $(".js-del-orderline").on("click", function (e) {
        e.preventDefault();
        //block form..
        $("#main-content").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<i class="fa fa-spinner fa-spin"></i>' });
        $.get($(e.currentTarget).attr("href"))
            .always(function () {
                //unblock form..
                $("#main-content").unblock();
            })
            .done(function (data, textStatus, jqXHR) {
                if (textStatus == "success") {
                    $("#main-content").replaceWith($(data).find("#main-content"));
                    $(".minicart-wrap").replaceWith($(data).find(".minicart-wrap"));
                    setupIncDec();
                    configureOrderUpdate();
                } else jqXHR.reject();
            })
            .fail(function () {
                //..
            });
    })

    /*
    $("#EcomOrderVoucherCode").on("keyup", function (e) { // ---> KT
        if ((e.keyCode || e.which) == 13) {
            e.preventDefault();
            $(e.target).closest(".row").find("button").click();
        }
    });*/


}



var filterResult = "";
var filterState = "";

$(document).ready(function () {

    setupIncDec();
    configureOrderUpdate();

    addBasketEventListener($(".js-ecom-product-form"));

    /*
    //cart orderlines
    $(".js-update-line").click(function (e) {
        e.preventDefault();
        console.log("updline");
        var orderlineId = $(this).attr("data-orderline-id");
        var url = $(".js-ecom-container").attr("data-cart-id");
        if (!orderlineId) return false;
        //console.log("update");
        //if (!validateFields($(this).closest(".js-orderline"))) return false;
        // Find input box containing quantity
        var orderlineCode = "QuantityOrderLine" + orderlineId;
        var box = $("input#" + orderlineCode);

        // Verify box
        if (!box) return false;
        // Do the update
        var val = parseInt(box.val()), url;

        if (val <= 0) {
            url = "CartCmd=delorderline&key=" + orderlineId;
        } else {
            url = "CartCmd=updateorderlines&" + orderlineCode + "=" + val;
        }
        
        //block form..
        $.get($("#ordersubmit").data("ajaxCart") + "&" + url)
            .always(function () {
                 //unblock form..
            })
            .done(function (data, textStatus, jqXHR) {
                if (textStatus == "success") {
                    $("#main-content").replaceWith($(data).find("#main-content"));
                } else jqXHR.reject();
            })
            .fail(function () {
                //..
            });
            
        //redirect("/Default.aspx?" + url);

        return false;
    });*/


    //back button
    $(".js-goback").click(function (e) {
        var $previousBtn = $(".js-previous-step")[0];

        $(".js-terms-and-conditions").prop("checked", false)
        if ($previousBtn.length == 0) {
            console.log("0")
            e.preventDefault();
            history.back(1);
        } else {
            console.log("1")
            $previousBtn.click();
        }
    });



    //delivery fields in checkout
    $(document).on("change", ".js-checkout-show-deliveryfields", function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr("data-target");
        var inputFields = $(".js-checkout-deliveryfields .form-control");
        e.stopPropagation();

        if ($(target).is(":visible")) {
            $(target).hide();
            inputFields.removeClass("js-req");
        } else {
            $(target).show();
            inputFields.addClass("js-req");
        }
    });





    $("input.js-ecom-product-quantity").focus(function () { $(this).select(); });


    //deliveryfields


    //slick sliders for product images and thumbs
    //thumb navigation for product-images 
    $(".js-product-thumbs").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        centerMode: true,
        focusOnSelect: true,
        arrows: true,
        asNavFor: '.js-product-images'
    });
    $(".js-product-images").slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.js-product-thumbs'
    });

    //productlist sort
    $(document).on("change", ".js-sort-list", function () {
        var urlWithParams = $(this).val();
        var url = urlWithParams.substring(0, urlWithParams.indexOf("?")); //Get the first part of the url
        var params = urlWithParams.substring(urlWithParams.indexOf("?") + 1, urlWithParams.length); //Get the params part of the url
        if (params.indexOf("Redirect") == -1) {
            params += "&Redirect=false";
        }
        console.log(params)

        //Remove ID
        var paramsForState = "";
        var ParamsArray = params.split("&");
        var count = 0;
        for (var i = 0; i < ParamsArray.length; i++) {
            if (ParamsArray[i] != "" && ParamsArray[i].toLowerCase().indexOf("id") != 0) {
                if (count > 0) {
                    paramsForState += "&";
                }
                paramsForState += ParamsArray[i];
                count++;
            }
        }

        //console.log(paramsForState)
        window.history.replaceState(null, document.title, window.location.href.split(/[?#]/)[0] + "?" + paramsForState)
        //console.log("url: " + url);
        if (url) {
            $(".list-sort-wrapper").addClass("loading");
            $.ajax(
                {
                    url: url,
                    type: "GET",
                    data: params,
                    dataType: "html",
                    //cache: false,
                    traditional: true,
                    complete: function (jqXHR, status) {
                        $(".list-sort-wrapper").removeClass("loading");
                    },
                    success: function (data, textStatus, jqXHR) {
                        var response = $(data).find(".js-ecom-content-row");
                        //console.log(response);
                        $(".js-ecom-content").html(response);
                        $("body").trigger("eCom:PageChanged");
                        addBasketEventListener($(".js-ecom-product-form"));

                        //track
                        // $(window).trigger("sp_product_list_filtered");
                        window.dispatchEvent(new CustomEvent('sp_product_list_filtered'));
                        $(".js-productlist-item a").on("click", function () {
                            window.dispatchEvent(new CustomEvent('sp_product_clicked', { "detail": { "pid": $(this).closest("form").attr("name") } }));
                            //$(window).trigger("sp_product_clicked", [$(this).closest("form").attr("name")]);
                        });


                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        console.log(jqXHR);
                        console.log(textStatus);
                        console.log(errorThrown);
                    }
                });
            // make button not focused
            //$(".js-ecom-product-button").blur();
            return false;
        } else {
            //console.log("url not defined"); //TODO: Should be an alert
            return false;
        }

    });

    ////productlist sort
    //$(document).on("change", ".js-sort-list", function () {
    //    var url = $(this).val();

    //    if (url) {
    //        $.ajax(
    //        {
    //            url: url,
    //            type: "POST",
    //            data: $(this).serialize(),
    //            dataType: "html",
    //            cache: false,
    //            traditional: true,
    //            beforeSend: function () {
    //            },
    //            complete: function (jqXHR, status) {
    //            },
    //            success: function (data, textStatus, jqXHR) {
    //                 var response = $(data).find(".js-ecom-content-row");
    //                //console.log(response);
    //                $(".js-ecom-content").html(response);
    //            },
    //            error: function (jqXHR, textStatus, errorThrown) {
    //                console.log(jqXHR);
    //                console.log(textStatus);
    //                console.log(errorThrown);
    //            }
    //        });
    //        // make button not focused
    //        //$(".js-ecom-product-button").blur();
    //        return false;
    //    } else {
    //        console.log("url not defined"); //TODO: Should be an alert
    //        return false;
    //    }

    //});

    //filters ajax event
    $("body").on("eCom:PageChange", function (evt, link, params) {
        //console.log("destination");
        //console.log(link);
        //console.log(params);
        var isMobileFilters = $("#mobile-filter-toggle").is(":visible") && $(".js-productlist-filters-container").is(":visible");

        //console.log(evt);
        if (link) {
            //startLoading(); // show loader
            //animation.startLoading();
            $(".js-ecom-productlist-facet-spinner").html("<i class='fa fa-spinner fa-spin pull-right js-ecom-productlist-facet-spinner'></i>");

            $.ajax(link)
            .done(function (response) {
                filterResult = response;
                filterState = link;
                if (isMobileFilters) {
                    
                    if (isMobileFilters && $(".js-productlist-filters-container").is(":visible")) {
                        $(".js-productlist-filters-container").replaceWith($(response).find(".js-productlist-filters-container"));
                        $(".js-productlist-filters-container").show();
                        filter_clone_mobile = $(".js-productlist-filters-container").clone(true);
                    }

                } else {
                   
                    var responseHTML = $(response).find(".js-ecom-page-container").html();
                    $(".js-ecom-page-container").html(responseHTML);
                    var currentState = null | history.state;
                    History.pushState(currentState, document.title, link); // logs {}, '', "?state=4"
                    filter_clone_mobile = "";


                    if (eCommerce) {
                        eCommerce.Overlay.hide();
                    }
                    
                    addBasketEventListener($(".js-ecom-product-form"));

                    //filter_clone = $(".js-productlist-filters-container").clone(true);
                    //filter_clone_mobile = $(".js-productlist-filters-container").clone(true);
                    //bind addtobasket after ajax
                    
                   // $("body").trigger("eCom:PageChanged");

                }
                $(openFacets.join(",")).addClass("active");
                $("body").trigger("eCom:PageChanged");
                

                

                //animation.endLoading();
                $(".js-ecom-productlist-facet-spinner").html("<i class='pull-right js-ecom-productlist-facet-spinner'></i>");
            });
        }
    });

});